export const CARD_DRAFT_TYPES = {
  SIMPLE: 'simple',
  NORMAL: 'normal',
  ARTICLE: 'article',
  DIALOG: 'dialog',
};

export const CARD_TEMPLATES = {
  [CARD_DRAFT_TYPES.SIMPLE]: `---
안녕
Hi.
---`,
  [CARD_DRAFT_TYPES.NORMAL]: `---
@word: false
@pre: Hi!
@Q: 안녕
@front: 기본
@A: Hi!
@back: Hello
@after: How are you?
---`,
  [CARD_DRAFT_TYPES.ARTICLE]: `---
@R: Helpful Thoughts
@Story:
Hi.
I hope this is helpful.
---`,
  [CARD_DRAFT_TYPES.DIALOG]: `---
@R: Morning Workout
@Story:
Hi.
I hope this is helpful.
@A name: A
@B name: B
@Scene: English PT club
@A: 좋은 아침!
Morning!
@B: 좋은 아침!
Morning!
@A: 운동할 준비됐어?
Ready to work out?
@B: 네!
Yes!
---`,
};

export const ALL_CARD_TEMPLATES = Object.values(CARD_TEMPLATES).join('\n\n');

export function getCardTemplate(type) {
  return CARD_TEMPLATES[type] || CARD_TEMPLATES[CARD_DRAFT_TYPES.SIMPLE];
}

